import { useCallback } from 'react';

import { SetPropertyUpdater } from 'src/pages/property-settings/PropertySettingsPageTypes';

import { usePropertySettings } from '../../context';
import { setDraft } from '../../state';

/**
 * Returns a stable `setProperty` function compatible with legacy SetPropertyType.
 * The updater function (prev => next) is resolved inside the reducer,
 * so the callback only depends on `dispatch` which is stable by React's guarantee.
 */
export function useSetProperty(): (updater: SetPropertyUpdater) => void {
	const { dispatch } = usePropertySettings();

	return useCallback(
		(updater: SetPropertyUpdater) => {
			dispatch(setDraft(updater));
		},
		[dispatch]
	);
}
